const ascLines = {
  1: {
    1: { x1: 126, y1: 28, x2: 144, y2: 10 },
    2: { x1: 126, y1: 34, x2: 150, y2: 10 },
    3: [
      { label: "1", x: 222, y: 120 },
      { label: "2", x: 338, y: 120 },
      { label: "3", x: 454, y: 120 },
      { label: "4", x: 454, y: 236 },
      { label: "5", x: 454, y: 352 },
      { label: "6", x: 454, y: 468 },
      { label: "7", x: 338, y: 468 },
      { label: "8", x: 222, y: 468 },
      { label: "9", x: 106, y: 468 },
      { label: "10", x: 106, y: 352 },
      { label: "11", x: 106, y: 236 },
      { label: "12", x: 106, y: 120 },
    ],
  },
  2: {
    1: { x1: 242, y1: 28, x2: 260, y2: 10 },
    2: { x1: 242, y1: 34, x2: 266, y2: 10 },
    3: [
      { label: "12", x: 222, y: 120 },
      { label: "1", x: 338, y: 120 },
      { label: "2", x: 454, y: 120 },
      { label: "3", x: 454, y: 236 },
      { label: "4", x: 454, y: 352 },
      { label: "5", x: 454, y: 468 },
      { label: "6", x: 338, y: 468 },
      { label: "7", x: 222, y: 468 },
      { label: "8", x: 106, y: 468 },
      { label: "9", x: 106, y: 352 },
      { label: "10", x: 106, y: 236 },
      { label: "11", x: 106, y: 120 },
    ],
  },
  3: {
    1: { x1: 358, y1: 28, x2: 376, y2: 10 },
    2: { x1: 358, y1: 34, x2: 382, y2: 10 },
    3: [
      { label: "11", x: 222, y: 120 },
      { label: "12", x: 338, y: 120 },
      { label: "1", x: 454, y: 120 },
      { label: "2", x: 454, y: 236 },
      { label: "3", x: 454, y: 352 },
      { label: "4", x: 454, y: 468 },
      { label: "5", x: 338, y: 468 },
      { label: "6", x: 222, y: 468 },
      { label: "7", x: 106, y: 468 },
      { label: "8", x: 106, y: 352 },
      { label: "9", x: 106, y: 236 },
      { label: "10", x: 106, y: 120 },
    ],
  },
  4: {
    1: { x1: 358, y1: 144, x2: 376, y2: 126 },
    2: { x1: 358, y1: 150, x2: 382, y2: 126 },
    3: [
      { label: "10", x: 222, y: 120 },
      { label: "11", x: 338, y: 120 },
      { label: "12", x: 454, y: 120 },
      { label: "1", x: 454, y: 236 },
      { label: "2", x: 454, y: 352 },
      { label: "3", x: 454, y: 468 },
      { label: "4", x: 338, y: 468 },
      { label: "5", x: 222, y: 468 },
      { label: "6", x: 106, y: 468 },
      { label: "7", x: 106, y: 352 },
      { label: "8", x: 106, y: 236 },
      { label: "9", x: 106, y: 120 },
    ],
  },
  5: {
    1: { x1: 358, y1: 260, x2: 376, y2: 242 },
    2: { x1: 358, y1: 266, x2: 382, y2: 242 },
    3: [
      { label: "9", x: 222, y: 120 },
      { label: "10", x: 338, y: 120 },
      { label: "11", x: 454, y: 120 },
      { label: "12", x: 454, y: 236 },
      { label: "1", x: 454, y: 352 },
      { label: "2", x: 454, y: 468 },
      { label: "3", x: 338, y: 468 },
      { label: "4", x: 222, y: 468 },
      { label: "5", x: 106, y: 468 },
      { label: "6", x: 106, y: 352 },
      { label: "7", x: 106, y: 236 },
      { label: "8", x: 106, y: 120 },
    ],
  },
  6: {
    1: { x1: 358, y1: 376, x2: 376, y2: 358 },
    2: { x1: 358, y1: 382, x2: 382, y2: 358 },
    3: [
      { label: "8", x: 222, y: 120 },
      { label: "9", x: 338, y: 120 },
      { label: "10", x: 454, y: 120 },
      { label: "11", x: 454, y: 236 },
      { label: "12", x: 454, y: 352 },
      { label: "1", x: 454, y: 468 },
      { label: "2", x: 338, y: 468 },
      { label: "3", x: 222, y: 468 },
      { label: "4", x: 106, y: 468 },
      { label: "5", x: 106, y: 352 },
      { label: "6", x: 106, y: 236 },
      { label: "7", x: 106, y: 120 },
    ],
  },
  7: {
    1: { x1: 242, y1: 376, x2: 260, y2: 358 },
    2: { x1: 242, y1: 382, x2: 266, y2: 358 },
    3: [
      { label: "7", x: 222, y: 120 },
      { label: "8", x: 338, y: 120 },
      { label: "9", x: 454, y: 120 },
      { label: "10", x: 454, y: 236 },
      { label: "11", x: 454, y: 352 },
      { label: "12", x: 454, y: 468 },
      { label: "1", x: 338, y: 468 },
      { label: "2", x: 222, y: 468 },
      { label: "3", x: 106, y: 468 },
      { label: "4", x: 106, y: 352 },
      { label: "5", x: 106, y: 236 },
      { label: "6", x: 106, y: 120 },
    ],
  },
  8: {
    1: { x1: 126, y1: 376, x2: 144, y2: 358 },
    2: { x1: 126, y1: 382, x2: 150, y2: 358 },
    3: [
      { label: "6", x: 222, y: 120 },
      { label: "7", x: 338, y: 120 },
      { label: "8", x: 454, y: 120 },
      { label: "9", x: 454, y: 236 },
      { label: "10", x: 454, y: 352 },
      { label: "11", x: 454, y: 468 },
      { label: "12", x: 338, y: 468 },
      { label: "1", x: 222, y: 468 },
      { label: "2", x: 106, y: 468 },
      { label: "3", x: 106, y: 352 },
      { label: "4", x: 106, y: 236 },
      { label: "5", x: 106, y: 120 },
    ],
  },
  9: {
    1: { x1: 10, y1: 376, x2: 28, y2: 358 },
    2: { x1: 10, y1: 382, x2: 34, y2: 358 },
    3: [
      { label: "5", x: 222, y: 120 },
      { label: "6", x: 338, y: 120 },
      { label: "7", x: 454, y: 120 },
      { label: "8", x: 454, y: 236 },
      { label: "9", x: 454, y: 352 },
      { label: "10", x: 454, y: 468 },
      { label: "11", x: 338, y: 468 },
      { label: "12", x: 222, y: 468 },
      { label: "1", x: 106, y: 468 },
      { label: "2", x: 106, y: 352 },
      { label: "3", x: 106, y: 236 },
      { label: "4", x: 106, y: 120 },
    ],
  },
  10: {
    1: { x1: 10, y1: 260, x2: 28, y2: 242 },
    2: { x1: 10, y1: 266, x2: 34, y2: 242 },
    3: [
      { label: "4", x: 222, y: 120 },
      { label: "5", x: 338, y: 120 },
      { label: "6", x: 454, y: 120 },
      { label: "7", x: 454, y: 236 },
      { label: "8", x: 454, y: 352 },
      { label: "9", x: 454, y: 468 },
      { label: "10", x: 338, y: 468 },
      { label: "11", x: 222, y: 468 },
      { label: "12", x: 106, y: 468 },
      { label: "1", x: 106, y: 352 },
      { label: "2", x: 106, y: 236 },
      { label: "3", x: 106, y: 120 },
    ],
  },
  11: {
    1: { x1: 10, y1: 144, x2: 28, y2: 126 },
    2: { x1: 10, y1: 150, x2: 34, y2: 126 },
    3: [
      { label: "3", x: 222, y: 120 },
      { label: "4", x: 338, y: 120 },
      { label: "5", x: 454, y: 120 },
      { label: "6", x: 454, y: 236 },
      { label: "7", x: 454, y: 352 },
      { label: "8", x: 454, y: 468 },
      { label: "9", x: 338, y: 468 },
      { label: "10", x: 222, y: 468 },
      { label: "11", x: 106, y: 468 },
      { label: "12", x: 106, y: 352 },
      { label: "1", x: 106, y: 236 },
      { label: "2", x: 106, y: 120 },
    ],
  },
  12: {
    1: { x1: 10, y1: 28, x2: 28, y2: 10 },
    2: { x1: 10, y1: 34, x2: 34, y2: 10 },
    3: [
      { label: "2", x: 222, y: 120 },
      { label: "3", x: 338, y: 120 },
      { label: "4", x: 454, y: 120 },
      { label: "5", x: 454, y: 236 },
      { label: "6", x: 454, y: 352 },
      { label: "7", x: 454, y: 468 },
      { label: "8", x: 338, y: 468 },
      { label: "9", x: 222, y: 468 },
      { label: "10", x: 106, y: 468 },
      { label: "11", x: 106, y: 352 },
      { label: "12", x: 106, y: 236 },
      { label: "1", x: 106, y: 120 },
    ],
  },
};

export default ascLines;
